"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var arguments_1 = require("./arguments");
var variables_1 = require("./variables");
/** Builds a GraphQL query AST from a QueryConfig object */
function buildQuery(_a) {
    var name = _a.name, entry = _a.entry, variables = _a.variables, fragments = _a.fragments;
    var variableDefinitions = variables_1.buildVariables(variables);
    var entryArgs = arguments_1.buildArguments(arguments_1.getArguments(variables, entry.args));
    var fragmentNodes = fragments.map(function (fragment) { return fragment.definitions[0]; });
    var fragmentsSet = {
        kind: "SelectionSet",
        selections: fragmentNodes.map(function (fragment) { return ({
            kind: "FragmentSpread",
            name: fragment.name,
            directives: [],
        }); }),
    };
    return {
        kind: "Document",
        definitions: [
            {
                kind: "OperationDefinition",
                operation: "query",
                name: {
                    kind: "Name",
                    value: name,
                },
                variableDefinitions: variableDefinitions,
                directives: [],
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "Field",
                            name: {
                                kind: "Name",
                                value: entry.name,
                            },
                            arguments: entryArgs,
                            directives: [],
                            selectionSet: entry.mapSelect ? entry.mapSelect(fragmentsSet) : fragmentsSet,
                        },
                    ],
                },
            }
        ].concat(fragmentNodes),
    };
}
exports.buildQuery = buildQuery;
